import script from "./OrganizationInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationInfos.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationInfos.vue?vue&type=style&index=0&id=b757ae86&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b757ae86"]])

export default __exports__